export default __webpack_public_path__ + "static/media/folder.e759d85a.svg";